import { EHeadingStyleVariant, Heading } from '@outdoorsyco/bonfire';
import Image from 'next/image';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import mediaUrl from '@/assets/referral/renter-heading.jpg';
import mobileMediaUrl from '@/assets/referral/renter-heading-mobile.jpg';
import { useBreakpoint } from '@/hooks/useBreakpoint';

import { Share } from './Share';

export const RenterHeading = () => {
  const { isMobile } = useBreakpoint();

  return (
    <div className="relative flex flex-col items-center px-4 py-10 min-h-[400px]">
      <div className="absolute inset-0 z-0">
        <Image
          alt=""
          src={isMobile ? mobileMediaUrl : mediaUrl}
          role="presentation"
          layout="fill"
          objectFit="cover"
          objectPosition="center"
          priority={true}
        />
      </div>

      <div className="absolute inset-0 z-1 bg-gradient-to-b from-black to-transparent opacity-30" />

      <div className="relative z-10 flex flex-col justify-center w-full text-center grow gap-6">
        <div className="flex flex-col text-white gap-2">
          <Heading variant={EHeadingStyleVariant.H3}>
            <FormattedMessage defaultMessage="Give $50. Get $75. It’s a win-win!" id="LqvprS" />
          </Heading>

          <Heading variant={EHeadingStyleVariant.H6}>
            <FormattedMessage
              defaultMessage="Help friends save on trips and earn credits for your own adventures."
              id="u+bnGG"
            />
          </Heading>
        </div>

        <Share />
      </div>
    </div>
  );
};
